import { Aseprite } from "@/game/libs/engine/sprite/aseprite";

export default class Yeti {
  public x: number;
  public y: number;
  public veloX: number;
  public veloY: number;
  public sprite: Aseprite;

  constructor(
    x: number,
    y: number,
    veloX: number,
    veloY: number,
    sprite: Aseprite
  ) {
    this.x = x;
    this.y = y;
    this.veloX = veloX;
    this.veloY = veloY;
    this.sprite = sprite;
  }

  reset() {
    this.x = 0;
    this.y = 0;
    this.veloX = 0;
    this.veloY = 0;
    this.sprite = null as any;
  }
}
